import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

// Configure axios to send cookies with requests
axios.defaults.withCredentials = true;

axios.interceptors.request.use((request: InternalAxiosRequestConfig) => {
  // Cookies are automatically sent with withCredentials: true
  // No need to manually add token to headers
  return request;
});

axios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    console.error('HTTP Error:', error);
    
    if (error?.response) {
      console.error('Response Error:', {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data,
        url: error.response.config?.url
      });
    }
    
    return Promise.reject(error);
  }
);

interface RequestConfig {
  BASE_URL: string;
  END_POINT: string;
  params?: any;
  data?: any;
  headers?: any;
}

class HttpClient {
  static async GET(config: RequestConfig): Promise<AxiosResponse> {
    return axios.get(`${config.BASE_URL}${config.END_POINT}`, {
      params: config.params,
      headers: config.headers,
      withCredentials: true
    });
  }

  static async POST(config: RequestConfig): Promise<AxiosResponse> {
    return axios.post(`${config.BASE_URL}${config.END_POINT}`, config.data, {
      headers: config.headers,
      withCredentials: true
    });
  }

  static async PATCH(config: RequestConfig): Promise<AxiosResponse> {
    return axios.patch(`${config.BASE_URL}${config.END_POINT}`, config.data, {
      headers: config.headers,
      withCredentials: true
    });
  }

  static async PUT(config: RequestConfig): Promise<AxiosResponse> {
    return axios.put(`${config.BASE_URL}${config.END_POINT}`, config.data, {
      headers: config.headers,
      withCredentials: true
    });
  }

  static async DELETE(config: RequestConfig): Promise<AxiosResponse> {
    return axios.delete(`${config.BASE_URL}${config.END_POINT}`, {
      headers: config.headers,
      withCredentials: true
    });
  }
}

export default HttpClient;
